import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import HomeIcon from '@mui/icons-material/HomeOutlined';
import SettingsIcon from '@mui/icons-material/SettingsOutlined';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import DesktopMacIcon from '@mui/icons-material/DesktopMac';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import DescriptionIcon from '@mui/icons-material/Description';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import DashboardIcon from '@mui/icons-material/DashboardOutlined';
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
import SettingsInputComponentIcon from '@mui/icons-material/SettingsInputComponent';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import TimelineIcon from '@mui/icons-material/Timeline';
import DataThresholdingIcon from '@mui/icons-material/DataThresholding';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import SsidChartIcon from '@mui/icons-material/SsidChart';
import ConstructionIcon from '@mui/icons-material/Construction';
import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearch';
import ArchiveIcon from '@mui/icons-material/Archive';
import CalendarMonthIcon from '@mui/icons-material/CalendarToday';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import PublicIcon from '@mui/icons-material/Public';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';
import config from '../../../../configuration/configuration.js';

export default [
	{
		title: '',
		pages: [
			{
				title: 'Home',
				href: '/home',
				icon: HomeIcon,
				// roles: ['Administrator', ...]
			},
		],
	},

	{
		title: 'Menu',
		pages: [
			{
				title: 'IP Assignment',
				href: '/ipassignment',
				icon: AssignmentIcon,
				roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
				projects: ['Core'],
				children: [
					{
						title: 'Service IP Assignment',
						href: '/ipassignment/serviceipassignment',
					},
					{
						title: 'Transport IP Assignment',
						href: '/ipassignment/transportipassignment',
					},
					{
						title: 'Remove E-Band IPs',
						href: '/ipassignment/removeebandips',
					}
				],
			},
			{
				title: 'IP Audits',
				href: '/ipaudits',
				icon: ManageSearchIcon,
				roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
				projects: ['Core'],
			}, /* ,
			{
				title: 'tickets',
				href: '/tickets',
				icon: ManageSearchIcon,
				roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
				projects: ['Ran'],
			} */
			{
				title: 'Kpis',
				href: '/kpis',
				icon: ShowChartIcon,
				roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
				projects: ['Operations'],
				children: [
					{
						title: 'Uploads',
						href: '/kpis/uploads',
					},
					{
						title: 'Reports',
						href: '/kpis/reports',
					}
				],
			},
			{
				title: 'Scripts',
				href: '/scripts',
				icon: DescriptionIcon,
				roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
				projects: ['Operations'],
				children: [
					{
						title: 'Tech Add',
						href: '/scripts/techadd',
					},
					{
						title: 'SCF',
						href: '/scripts/scf',
					},
					{
						title: 'BW Update',
						href: '/scripts/bwupdate',
					}
				],
			},
			{
				title: 'CM',
				href: '/cm',
				icon: SettingsInputComponentIcon,
				roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
				projects: ['Operations', 'Ran'],
				children: [
					{
						title: 'Configuration',
						href: '/cm/configuration',
					},
					{
						title: 'CellInfo',
						href: '/cm/cellinfo',
					},
					{
						title: 'Huawei Remote Analysis',
						href: '/cm/huaweiremoteanalysis',
					},
					{
						title: 'Incident CellList',
						href: '/cm/incidentcelllist',
					}
				],
			},
			{
				title: 'Combined DCR',
				href: '/dashboards/inspect/30',
				icon: AutoGraphIcon,
				roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
				projects: ['Ran'],
			},
			{
				title: 'Dynamic Clusters',
				href: 'DynamicClusters',
				icon: DataThresholdingIcon,
				roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
				projects: ['Ran'],
				children: [
					{
						title: '2G',
						href: '/DynamicClusters',
						children: [
							{
								title: 'Sites',
								href: '/dashboards/inspect/63'
							},
							{
								title: 'Cells',
								href: '/dashboards/inspect/62'
							}
						]
					},
					{
						title: '4G',
						href: '/DynamicClusters',
						children: [
							{
								title: 'Sites',
								href: '/dashboards/inspect/22'
							},
							{
								title: 'Cells',
								href: '/dashboards/inspect/21'
							}
						]
					},
					{
						title: '5G',
						href: '/DynamicClusters',
						children: [
							{
								title: 'Sites',
								href: '/dashboards/inspect/65'
							},
							{
								title: 'Cells',
								href: '/dashboards/inspect/64'
							}
						]
					}
				],
			},
			{
				title: 'Small Cells',
				href: '/smallcells',
				icon: AssessmentOutlinedIcon,
				roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
				projects: ['Ran'],
				children: [
					{
						title: 'Reports',
						href: '/smallcells/reports',
					},
					{
						title: 'Dashboard',
						href: '/dashboards/inspect/15',
					}
				],
			},
			{
				title: 'Projects Dashboards',
				href: '/ProjectsDashboards',
				icon: SsidChartIcon,
				projects: ['Ran'],
				children: [
					{
						roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
						title: 'EEUK-RANPO-ACCEPTANCE',
						href: '/dashboards/inspect/96',
					},
					{
						roles: ['Client'],
						title: 'EEUK-RANPO-ACCEPTANCE',
						href: '/dashboards/inspect/102',
					},
					{
						title: 'EEUK-RANPO-ACCEPTANCE-WORK_MANAGEMENT',
						roles: ['Administrator', 'Manager'],
						href: '/dashboards/inspect/119',
					},
					{
						title: 'EEUK-VIPCMP',
						children: [
							{
								roles: ['Client'],
								title: 'Status Report',
								href: '/dashboards/inspect/101',
							},
							{
								roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
								title: 'Status Report',
								href: '/dashboards/inspect/97',
							},
							{
								title: 'KPI Performance Analysis',
								children: [
									{
										roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
										title: 'Cell',
										href: '/dashboards/inspect/103',
									},
									{
										roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
										title: 'Cluster',
										href: '/dashboards/inspect/114',
									}
								]
							}
						]
					},
					{
						roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
						title: 'EEUK-RANPO-REGIONAL',
						href: '/dashboards/inspect/100',
					}
				],
			},
			/* ,
			{
				title: 'RF OPT Tracker',
				href: '/RFOPTTracker',
				icon: TrackChangesIcon,
				roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
				projects: ['Ran'],
			} */
			{
				title: 'Network Performance Monitoring',
				href: '/NetworkPerformanceMonitoring',
				icon: PublicIcon,
				projects: ['Ran'],
				children: [
					{
						title: 'Main KPIs',
						roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
						children: [
							{
								title: 'Daily',
								href: '/dashboards/inspect/111'
							},
							{
								title: 'Hourly',
								href: '/dashboards/inspect/112'
							}
						],
					},
					{
						title: 'KPI Performance',
						roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
						children: [
							{
								title: '5G',
								href: '/dashboards/inspect/105'
							},
							{
								title: '4G',
								href: '/dashboards/inspect/106'
							}
						],
					},
					{
						title: 'Undetected Faults',
						children: [
							{
								title: '5G',
								roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
								href: '/dashboards/inspect/107'
							},
							{
								title: '4G',
								roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
								href: '/dashboards/inspect/113'
							}
						],
					},
					{
						title: 'Top Offenders',
						// roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
						children: [
							{
								title: 'Overall',
								roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
								href: '/dashboards/inspect/117'
							},
							{
								title: 'Delta Drops',
								roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
								href: '/dashboards/inspect/92'
							},
							/* 							{
								title: 'Reports',
								href: '/NetworkPerformanceMonitoring',
								children: [
									{
										title: 'Worst Sites',
										children: [
											{
												title: 'Region',
												href: '/NetworkPerformanceMonitoring/WorstSitesRegion'
											},
											{
												title: 'Sub Region',
												href: '/NetworkPerformanceMonitoring/WorstSites'
											},
											{
												title: 'Cities',
												href: '/NetworkPerformanceMonitoring/WorstSitesCities'
											}
										],
									},
									{
										title: 'Performance',
										children: [
											{
												title: 'Sub Region',
												href: '/NetworkPerformanceMonitoring/HardySubRegions'
											},
											{
												title: 'Cities',
												href: '/NetworkPerformanceMonitoring/HardyCities'
											}
										],
									},
									{
										title: 'Week Agg',
										children: [
											{
												title: 'Region',
												href: '/NetworkPerformanceMonitoring/TopOffendersAggRegion'
											},
											{
												title: 'Sub Region',
												href: '/NetworkPerformanceMonitoring/TopOffendersAggSubRegion'
											},
											{
												title: 'Cities',
												href: '/NetworkPerformanceMonitoring/TopOffendersAggCity'
											}
										],
									},
									{
										title: 'Site Agg',
										href: '/NetworkPerformanceMonitoring/TopOffendersAggSite'
									},
									{
										title: 'Capacity PRB Black List',
										href: '/NetworkPerformanceMonitoring/CapacityPRBBlackList'
									},
									{
										title: 'Weekly Report',
										href: '/dashboards/inspect/87'
									}
								]
							}, */
							{
								title: 'Regions',
								roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
								href: '/NetworkPerformanceMonitoring',
								children: [
									{
										title: 'Dashboards',
										children: [
											{
												title: 'Main KPIs',
												href: '/dashboards/inspect/60'
											},
											{
												title: 'Worst Sites & Sleeping Cells',
												href: '/dashboards/inspect/61'
											}
										],
									},
									{
										title: 'Reports',
										children: [
											{
												title: 'Worst Sites (Impacted & Sorted)',
												href: '/NetworkPerformanceMonitoring/WorstSitesRegion'
											},
											{
												title: 'Region Week Agg',
												href: '/NetworkPerformanceMonitoring/TopOffendersAggRegion'
											}
										],
									}
								],
							},
							{
								title: 'Sub Regions',
								roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
								children: [
									{
										title: 'Dashboards',
										children: [
											{
												title: 'Main KPIs',
												href: '/dashboards/inspect/58'
											},
											{
												title: 'Worst Sites & Sleeping Cells',
												href: '/dashboards/inspect/59'
											}
										],
									},
									{
										title: 'Reports',
										children: [
											{
												title: 'Performance Monitoring',
												href: '/NetworkPerformanceMonitoring/HardySubRegions'
											},
											{
												title: 'Worst Sites (Impacted & Sorted)',
												href: '/NetworkPerformanceMonitoring/WorstSites'
											},
											{
												title: 'Sub Region Week Agg',
												href: '/NetworkPerformanceMonitoring/TopOffendersAggSubRegion'
											},
											{
												title: 'Capacity PRB Black List',
												href: '/NetworkPerformanceMonitoring/CapacityPRBBlackList'
											}
										],
									}
								],
							},
							{
								title: 'Cities',
								roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
								children: [
									{
										title: 'Dashboards',
										children: [
											{
												title: 'Main KPIs',
												href: '/dashboards/inspect/56'
											},
											{
												title: 'Worst Sites & Sleeping Cells',
												href: '/dashboards/inspect/57'
											}
										],
									},
									{
										title: 'Reports',
										children: [
											{
												title: 'Performance Monitoring',
												href: '/NetworkPerformanceMonitoring/HardyCities'
											},
											{
												title: 'Worst Sites (Impacted & Sorted)',
												href: '/NetworkPerformanceMonitoring/WorstSitesCities'
											},
											{
												title: 'City Week Agg',
												href: '/NetworkPerformanceMonitoring/TopOffendersAggCity'
											}
										],
									}
								],
							},
							{
								title: 'Reports',
								roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
								children: [
									{
										title: 'Site Agg',
										href: '/NetworkPerformanceMonitoring/TopOffendersAggSite'
									},
									{
										title: 'Weekly Report',
										href: '/dashboards/inspect/87'
									}
								],
							}
						]
					},
					{
						title: 'Focus Occasion',
						roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
						children: [
							{
								title: 'Dashboard',
								href: '/dashboards/inspect/83',
							},
							{
								title: 'Events Upload',
								href: '/FocusOccasion/EventsUpload'
							}
						],
					}
				],
			},
			{
				title: 'Acceptance',
				href: '/acceptance',
				icon: SignalCellularAltIcon,
				roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
				projects: ['Ran'],
				children: [
					{
						title: 'Swap',
						href: '/swap',
						children: [
							{
								title: '2G',
								href: '/swap',
								children: [
									{
										title: 'Daily',
										href: '/dashboards/inspect/2'
									}
								],
							},
							{
								title: '4G',
								href: '/swap',
								children: [
									{
										title: 'Daily',
										href: '/dashboards/inspect/6'
									},
									{
										title: 'Hourly',
										href: '/dashboards/inspect/20'
									}
								],
							},
							{
								title: '5G',
								href: '/swap',
								children: [
									{
										title: 'Daily',
										href: '/dashboards/inspect/10'
									}
								],
							}
						]
					},
					{
						title: 'Airscale',
						href: '/airscale',
						children: [
							{
								title: '2G',
								href: '/dashboards/inspect/27'
							},
							{
								title: '4G',
								href: '/dashboards/inspect/28'
							}
						],
					},
					{
						title: 'Reports',
						href: '/acceptance/reports',
						children: [
							{
								title: '2CA',
								href: '/acceptance/reports/2ca',
							},
							{
								title: 'NR',
								href: '/acceptance/reports/nr',
							},
							{
								title: 'RF',
								href: '/acceptance/reports/rf',
							},
							{
								title: 'Site Power Boost',
								href: '/acceptanceTools/reports/sitePowerBoost',
							},
							{
								title: 'Sunset',
								href: '/acceptance/reports/sunset',
							}
						],
					}
				],
			},
			{
				title: 'Acceptance Tools',
				icon: ConstructionIcon,
				href: '/nr',
				projects: ['Ran', 'Operations'],
				roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
				children: [
					{
						title: 'CBO KPIs Global',
						href: '/dashboards/inspect/12',
					},
					{
						title: 'RETs Check',
						href: '/dashboards/inspect/95'
					},
					{
						title: 'BAU Daily Work',
						href: '/dashboards/inspect/98'
					},
					{
						title: 'Assigning Teams',
						href: '/acceptance/management',
					},
					{
						title: 'Site Tracker',
						href: '/dashboards/inspect/99'
					},
					{
						title: 'Incident Tracker',
						href: '/dashboards/inspect/104'
					},
					{
						title: 'Reports',
						href: '/acceptanceTools/reports',
						children: [
							{
								title: 'Dumps Export',
								href: '/acceptanceTools/reports/dumpsExport',
							},
							{
								title: 'NR (CBO)',
								href: '/acceptanceTools/reports/nr_cbo',
							},
							{
								title: 'NR Bulk Assessment',
								href: '/acceptanceTools/reports/nrBulkAssessment',
							},
							{
								title: 'RF Counters',
								href: '/acceptanceTools/reports/reportRFCounters',
							}
						],
					}
				],
			},
			{
				title: 'On Demand Report',
				icon: AppRegistrationIcon,
				href: '/onDemandReport',
				projects: ['Ran'],
				children: [
					{
						title: 'Overall',
						roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
						children: [
							{
								title: 'Daily',
								href: '/dashboards/inspect/116'
							},
							{
								title: 'Hourly',
								href: '/dashboards/inspect/118'
							}
						]
					},
					{
						title: '2G',
						roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
						href: '/dashboards/inspect/32'
					},
					{
						title: '4G',
						roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
						href: '/dashboards/inspect/33'
					},
					{
						title: '5G',
						roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
						href: '/dashboards/inspect/34'
					},
					{
						title: 'RET Enabling Checks',
						roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
						href: '/onDemandReport/retEnablingChecks'
					}
				],
			},
			{
				title: 'RET Tools',
				icon: ManageSearchIcon,
				href: '/retaudit',
				projects: ['Ran', 'Operations'],
				roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
				children: [
					{
						title: 'CPM Dumps',
						href: '/retaudit/CPMDumps'
					},
					{
						title: 'GEO Inputs',
						href: '/retaudit/GEOinput'
					},
					{
						title: 'Files Upload',
						href: '/retaudit/retfilesupload'
					}
				],
			},
			{
				title: 'Incidente Tracker',
				href: '/incidenttracker',
				icon: ContentPasteSearchIcon,
				roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
				projects: ['Operations'],
				children: [
					{
						title: 'Incidente Tracker',
						href: '/incidenttracker/incidenttracker',
					},
					{
						title: 'Incidente Tracker Configuration',
						href: '/incidenttracker/incidenttrackerconfiguration',
					}
				],
			},
			{
				title: 'Dashboards',
				href: '/dashboards',
				icon: DashboardIcon,
				roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
				projects: ['Operations'],
				children: [
					{
						title: 'Rollout',
						href: '/dashboards/inspect/1',
					},
					{
						title: 'KPIs Global',
						href: '/dashboards/inspect/12',
					},
					{
						title: 'KPIs Global Hourly',
						href: '/dashboards/inspect/115',
					},
					{
						title: 'TA Detail',
						href: '/dashboards/inspect/23',
					},
					{
						title: 'Data Integraty',
						href: '/dashboards/inspect/36',
					},
					{
						title: 'Acceptance',
						href: '/dashboards/inspect/86',
					},
					{
						title: 'INC Tracker DB',
						href: '/dashboards/inspect/94',
					}
				],
			},
			{
				title: 'Rollout',
				href: '/dashboards/inspect/1',
				icon: CalendarMonthIcon,
				roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
				projects: ['Operations']
			},
			{
				title: 'Site Tracker',
				href: '/sitetracker',
				icon: ContentPasteSearchIcon,
				roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
				projects: ['Operations'],
				children: [
					{
						title: 'Site Tracker',
						href: '/sitetracker/sitetracker',
					},
				],
			}
		],
	},
	{
		title: 'Management',
		pages: [
			{
				title: 'Manage',
				href: '/management',
				roles: ['Administrator', 'Manager'],
				icon: SupervisorAccountIcon,
				children: [
					{
						title: 'Operators',
						href: '/management/operators',
					},
					{
						title: 'Users',
						href: '/management/users',
					}
				],
			},
			{
				title: 'Hangfire',
				href: `${config.API_URL}hangfire?access_token={token}`,
				target: '_blank',
				roles: ['Administrator'],
				icon: DesktopMacIcon
			},
			{
				title: 'Settings',
				href: '/management/settings',
				icon: SettingsIcon
			},
			{
				title: 'Data Integrity',
				href: '/dashboards/inspect/17',
				icon: QueryStatsIcon,
				roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
			},
			{
				title: 'Statistics',
				href: '/dashboards/inspect/35',
				roles: ['Administrator', 'Manager'],
				icon: SsidChartIcon
			}
		],
	}
];
